import { FormikValues } from 'formik';

import { FormPage, FormPageProps } from 'src/legacy/components/Page/FormPage';

import { SettingsPageHeaderTitle } from './SettingsPageHeaderTitle';

export function SettingsPageForm<Values extends FormikValues>(
  props: FormPageProps<Values>,
) {
  return (
    <>
      <FormPage<Values>
        title={<SettingsPageHeaderTitle />}
        actionLabel="Update"
        isSettingsForm
        headerVariant="bottomBorder"
        xs={12}
        {...props}
      />
    </>
  );
}
